import switcher from "ai-switcher-translit";
import {Col, DatePicker, Form, Input, Row, Select} from "antd";
import React, {useState} from "react";
import {useFullVoc} from "../../hooks/voc.hook";
import ReactDadataBox from "react-dadata-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMap} from "@fortawesome/pro-light-svg-icons";
import {PatientMap} from "../../components/MapFiles/PatientMap";
import {IconPopup} from "./AntdHelper";


const withSpan = (frm, span) => span ? <Col span={span}>{frm}</Col> : frm
const withShouldUpdate = (frm, shouldUpdate) => shouldUpdate ? <Form.Item shouldUpdate={shouldUpdate}>{() => {return (frm)}}</Form.Item> : frm
export const withFormExt = (frm, span, shouldUpdate) => {
    console.log('su', shouldUpdate)
    return withSpan(withShouldUpdate(frm, shouldUpdate), span)
}

const stdFilter = (input, option) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
const advFilter = (input, option) =>
    stdFilter(input, option) ||
    stdFilter(switcher.getSwitch(input, {type: 'rueng'}), option) ||
    stdFilter(switcher.getSwitch(input, {type: 'engru'}), option) ||
    stdFilter(switcher.getSwitch(input, {type: 'retranslit'}), option)

export function RgSelect({
                             oid,
                             label,
                             name,
                             noStyle,
                             nodeTitle,
                             placeholder,
                             compact,
                             width,
                             mode,
                             span,
                             rules,
                             shouldUpdate,
                             disabled,
                             labelCol,
                             wraperCol,
                             dependencies
                         }) {
    const voc = useFullVoc(oid)

    const frm = <Form.Item label={label} noStyle={noStyle} name={name} style={{width}} rules={rules}
                           labelCol={labelCol} wrapperCol={wraperCol}
                           shouldUpdate={shouldUpdate} dependencies={dependencies}>
        <Select
            placeholder={placeholder}
            showSearch
            optionFilterProp="children"
            mode={mode}
            filterOption={advFilter}
            disabled={disabled}
        >
            {(voc || []).map((d, i) => <Select.Option key={d.value + '_' + i}
                                                      value={d.value}>{nodeTitle ? d[nodeTitle] : d.title}</Select.Option>)}
        </Select>
    </Form.Item>;

    return withFormExt(frm, span, shouldUpdate)
}

export function RgInput({label, name, span, offset, rules, shouldUpdate, disabledFunc, disabled, labelCol, wraperCol, form}) {
    console.log('render 11')
    const frm = <Form.Item label={label} rules={rules} name={name} shouldUpdate={shouldUpdate} labelCol={labelCol} wrapperCol={wraperCol}>
        <Input disabled={disabled}// disabled={disabledFunc ? disabledFunc() : false}
        //
        />
    </Form.Item>
    return withFormExt(frm, span, shouldUpdate)

}

export function RgDatePicker({label, name, span, rules, shouldUpdate, disabled}) {
    return withFormExt(
    <Form.Item label={label} name={name} rules={rules}>
        <DatePicker disabled={disabled} ></DatePicker>
    </Form.Item>
, span, shouldUpdate)
}

export const RgAddr = ({onChange, name, label, value}) => {
    const [open, setOpen] = useState(false)
    const [chord, setChord] = useState({})

    const changeHandler = (val) => {
        setChord({position: [val.data.geo_lat, val.data.geo_lon], text: val.value})
        if (typeof (onChange) === 'function')
            onChange(val)
        console.log("chord", val)
    }
    return <Row gutter={6}>
        <Col span={22}>
            <Form.Item name={name} label={label}>
                <ReactDadataBox token="04d449e9fa9cea97cf197d3d3daaea2ab299e0ba" query={value || "г. Санкт-Петербург,"}
                                onChange={changeHandler}/>
            </Form.Item>
        </Col>
        <Col span={2}>
            <IconPopup Icon={({onClick}) => <FontAwesomeIcon onClick={() => onClick()} size={"lg"} icon={faMap}/>}>
                <PatientMap marker={chord}/>
            </IconPopup>
        </Col>
    </Row>
}